import React, { useRef, useState} from "react";
import styles from "@/styles/HomeUserCalc.module.scss"
import {LocalLanguage} from "@/types_and_interfaces/types";
import {useTranslation} from "react-i18next";
import Button from "@/ui/Button.tsx";
import CMS from "@/utils/cms";
import {country_code} from "@/utils/constants.ts";
import CalculatorCore from "@/components/calculator_components/CalculatorCore.tsx";
import SwitcherMobile from "@/components/calculator_components/MobileCalulatorSwitcher.tsx";
import useAuth from "@/hooks/auth";
import PhoneNumberInput from "@/ui/PhoneNumberInput.tsx";
import DashboardClass from "@/utils/dashboard_class.ts";
import { useNavigate } from 'react-router-dom';
import CloseBtn from "@/ui/CloseButton.tsx";
import useCalc from "@/hooks/calculator.ts";
import {CircularProgress} from "@mui/material";
import CommonClass from "@/utils/common.ts";
import CalculatorLimit from "@/types_and_interfaces/calculator_limit.ts";
import eventEmitter from "@/utils/event_emmiter_instance.ts";
import ProductInterface from "@/types_and_interfaces/product_interface.ts";
// import {useAtom} from "jotai/index";
// import {pending_loans} from "@/atoms/common.ts";
import useLoans from "@/hooks/loans.ts";

interface Props {
    onClose?():void
}

const HomeDashboardCalculator:React.FC<Props> = ({onClose}) => {
    const genData = CMS.general_info
    const dc = DashboardClass
    const navigate = useNavigate();
    const calc = useCalc()
    const [numError, setNumError ] = useState<boolean>(false)
    const {t, i18n} = useTranslation()
    const checkbox = useRef<any>(null)
    const prod = calc.get_product() as ProductInterface
    // const [loans] = useAtom(pending_loans)
    // const common_hook = useCommon()
    const agreement = genData && CMS.langAwareFilter(genData, (i18n.language as LocalLanguage))?.agreement?.replace(/{{root}}/g, import.meta.env.VITE_WEBSITE_URL + "/" + i18n.language)?.replace("https://easycredit--dev.wippo-it.net", import.meta.env.VITE_WEBSITE_URL + "/" + i18n.language)
    const auth = useAuth()
    const user = auth.current_user()
    const user_phone = auth.current_user()?.phone
    const loan_hook = useLoans()
    let tempDiv = document.createElement('div');
    const form = useRef<any>(null)

    tempDiv.innerHTML = agreement;

    let links = tempDiv.querySelectorAll('a');
    links.forEach(link => {
        link.setAttribute('target', '_blank');
    });

    let updatedAgreement = tempDiv.innerHTML;
    
    const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        
        
        
        const form = new FormData(e.currentTarget)
        let enable = true
        const phone = form.get("phone")
        
        if(!prod || (typeof prod === "object" && !Object.keys(prod).length)) {
            eventEmitter.emit(CommonClass.CustomEvents.update_snackbar,"error", t("calculator_product_not_found"));
            enable = false
        }
        
        if(checkbox.current) {
            if(!form.has("checkbox") && user?.kyc_general_status !== "ProcessingSuccess") {
                checkbox.current.classList.add(styles.error)
                // common_hook.updateSnackbar("error", t("terms_agree"))
                eventEmitter.emit(CommonClass.CustomEvents.update_snackbar, "error", t("terms_agree"))
                enable = false
            } else {
                if(user?.kyc_general_status !== "ProcessingSuccess") {
                    checkbox.current.classList.remove(styles.error)
                }
            }
        }
        
        if(!phone && auth.current_user()?.phone === ""){
            eventEmitter.emit(CommonClass.CustomEvents.update_snackbar, "error", t("type_phone_number"))
            setNumError(true)
            enable = false
        } else {
            setNumError(false)
            
            if(phone && !CommonClass.phoneNumberValidate(phone as string)) {
                eventEmitter.emit(CommonClass.CustomEvents.update_snackbar, "error", t("valid_nr_err"))
                setNumError(true)
                enable = false
            } else {
                setNumError(false)
            }
        }

        if((phone && CommonClass.phoneNumberValidate(phone as string)) && !user?.phone.length) {
            eventEmitter.emit(CommonClass.ModalEvents.SetPhone, true, phone, t("set_phone_to_continue"))

            enable = false
        }
        
        if(user?.kyc_general_status !== "ProcessingSuccess") {
            if (!user?.permissions.is_loan_application_allowed) {
                if(loan_hook.pend_status_loans_length > 0) {
                    eventEmitter.emit(
                        CommonClass.CustomEvents.update_snackbar,
                        "info",
                        t("can_not_apply"),
                        t("pending_credit"),
                        () => {navigate(DashboardClass.dashboard_routes.PendingLoans)}
                    )
                } else {
                    eventEmitter.emit(
                        CommonClass.CustomEvents.update_snackbar,
                        "warning",
                        t("is_in_court_err").replace("{{number}}", CMS?.general_info?.phone_number)
                    )
                }
                
                return;
            }

            
        } else {
            
            if((calc.get_selected_type() as CalculatorLimit).category_name === "auto") {
                
                if (!user?.permissions.is_loan_auto_allowed) {
                    eventEmitter.emit(
                        CommonClass.CustomEvents.update_snackbar,
                        "info",
                        t("can_not_apply_auto_credit"),
                        t("pending_credit"),
                        () => {navigate(DashboardClass.dashboard_routes.PendingLoans)}
                    )
                    return;
                }
            }
            
            if((calc.get_selected_type() as CalculatorLimit).category_name === "personal" || (calc.get_selected_type() as CalculatorLimit).category_name === "refinance" ){
                
                if (!user?.permissions.is_loan_personal_or_refinance_allowed) {
                    
                    if((calc.get_selected_type() as CalculatorLimit).category_name === "refinance") {
                        eventEmitter.emit(
                            CommonClass.CustomEvents.update_snackbar,
                            "info",
                            t("can_not_apply_refinancing_credit"),
                            t("pending_credit"),
                            () => {navigate(DashboardClass.dashboard_routes.PendingLoans)}
                        )
                    }
                    
                    if((calc.get_selected_type() as CalculatorLimit).category_name === "personal") {
                        eventEmitter.emit(
                            CommonClass.CustomEvents.update_snackbar,
                            "info",
                            t("can_not_apply"),
                            t("pending_credit"),
                            () => {navigate(DashboardClass.dashboard_routes.PendingLoans)}
                        )
                    }
                    
                    return;
                }
                
            }
        }
        
        if (!enable) return


        loan_hook.pre_apply_loan(form, (calc.get_selected_type() as CalculatorLimit).category_name, user, prod.product_id)
        loan_hook.uncommited_loan(form, user);
        auth.redirectToApplyCredit(form, (calc.get_selected_type() as CalculatorLimit).category_name)
        localStorage.setItem(CommonClass.local_storage_fields.before_apply_cr, location.pathname)
        navigate(dc.dashboard_routes.ApplyCredit)
    }

    return (
        <div style={{position: "relative"}} className={styles.relative}>
            
            <div className={styles.main}>
                
                <div className={styles.add}>
                    
                    <div className={styles.labels}>
                        <strong>
                            {t("new_credit")}
                        </strong>
                        <span>
                            {t("calculate_loan")}
                        </span>
                    </div>
                    
                    {typeof onClose === "function"&& (
                        <CloseBtn onClick={onClose}/>
                    )}
                    
                </div>
                
                <form ref={form} onSubmit={onSubmit}>
                    
                    <SwitcherMobile
                        styles={styles}
                    />
                    
                    <div className={styles.calculator_body}>
                        <CalculatorCore styles={styles}/>
                    </div>
                    
                    <div className={styles.form_additional_inputs}>
                        
                        {!user?.phone.length && (
                            <PhoneNumberInput
                                disabled={Boolean(typeof user_phone === "string" && user_phone.length)}
                                defaultValue={(typeof user_phone === "string" && user_phone.length) ? CommonClass.formatNumber(user_phone.replace(country_code, "")) : undefined}
                                error={numError}
                            />
                        )}

                        <div className={styles.checkbox_cont}>

                            <input
                                className={styles.checkbox}
                                type={"checkbox"}
                                ref={checkbox}
                                name={"checkbox"}
                                defaultChecked={false}
                                color="success"
                                onChange={() => {
                                    if (!checkbox.current) return
                                    checkbox.current.style.outline = 'none'
                                    checkbox.current.style.borderRadius = '0'
                                }}
                                disabled={user?.identity_card_is_expired}
                                style={{ cursor: user?.identity_card_is_expired ? "default" : "pointer" }}

                            />

                            {(typeof agreement === "string" && agreement.length) ? (

                                <div className={styles.content} dangerouslySetInnerHTML={{__html: updatedAgreement}}/>

                            ) : null}
                        </div>

                        <Button type={"submit"} animated className={styles.submit_btn} disabled={user?.identity_card_is_expired}>
                            <span>
                                {t("apply_dashboard_calculator")}
                            </span>
                        </Button>
                    </div>
                    
                    {(() => {
                        const types = calc.get_types();
                        return (!types || (typeof types === "object" && Object.keys(types).length === 0)) && (
                            <div className={styles.blur}>
                                {!types && (
                                    <CircularProgress color={"success"}/>
                                )}
                                
                                {(typeof types === "object" && Object.keys(types).length === 0) && (
                                    <strong>
                                        {t("calculator_nor_working")}
                                    </strong>
                                )}
                            </div>
                        );
                    })()}
                
                </form>
            
            </div>
            
        </div>
    
    )
}


export default HomeDashboardCalculator